module.exports = __webpack_public_path__ + "static/img/bg_zhengce.5f5c6de.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/newImages/bg_zhengce.png
// module id = 2JI6
// module chunks = 1